var buildMediaContent = function buildMediaContent(postType) {
  var builtmediaContent = '<div class="weducNewsfeedMediaWrap">';

  if (postType && postType.items && postType.typeId) {
    var passedPostItems = postType.items;
    var passedPostTypeiD = postType.typeId;

    if (passedPostTypeiD == 1) {
      // Text type, no content
      return "";
    } else if (passedPostTypeiD == 2) {
      // Photo type, return image or images
      builtmediaContent += '<div class="%s">' + '<img src="' + passedPostItems[0].url + '" width="' + passedPostItems[0].width + '" height="' + passedPostItems[0].height + '">' + "</div>";
    } else if (passedPostTypeiD == 3) {
      // File type
      passedPostItems.forEach(function (postItemMedia, i) {
        builtmediaContent += "<a key=".concat(i, " href=\"").concat(postItemMedia.external_url, "\" target=\"_blank\">\n          ").concat(postItemMedia.title, "\n        </a>");
      });
    } else if (passedPostTypeiD == 4) {
      // Album type
      if (passedPostItems.count == 1) {
        builtmediaContent += '<div class="%s">' + '<img src="' + passedPostItems[0].url + '" width="' + passedPostItems[0].width + '" height="' + passedPostItems[0].height + '">' + "</div>";
      } else if (passedPostItems.count > 1) {
        passedPostItems.forEach(function (postItemMedia, i) {
          builtmediaContent += "<div key=".concat(i, " class=\"%s\">\n          <img alt=\"").concat(postItemMedia.title, "\" src=\"").concat(postItemMedia.url, "\" width=\"").concat(postItemMedia.width, "\" height=\"").concat(postItemMedia.height, "\" />\n        </div>");
        });
      }
    } else if (passedPostTypeiD == 5) {
      // Quiz type
      builtmediaContent += "";
    } else if (passedPostTypeiD == 6) {
      // Calendar type
      builtmediaContent += "";
    } else if (passedPostTypeiD == 7) {
      // Video type
      passedPostItems.forEach(function (postItemMedia, i) {
        builtmediaContent += "<video key=".concat(i, " width=\"320\" height=\"240\" controls>\n          <source alt=\"").concat(postItemMedia.title, "\" src=\"").concat(postItemMedia.url, "\" type=\"").concat(postItemMedia.mimeType, "\" poster=\"").concat(postItemMedia.poster, "\" width=\"").concat(postItemMedia.width, "\" height=\"").concat(postItemMedia.height, "\" />\n        </video>");
      });
    } else if (passedPostTypeiD == 8) {
      // Link type
      passedPostItems.forEach(function (postItemMedia, i) {
        var videoLink = postItemMedia.url.split("=>")[2] ? postItemMedia.url.split("=>")[2] : postItemMedia.url;

        if (postItemMedia.isVideo == true) {
          builtmediaContent += '<iframe width="100%" height="315" title="' + postItemMedia.title + '" src="' + videoLink + '" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>';
        } else if (postItemMedia.isIframe != 0) {
          builtmediaContent += '<iframe title="' + postItemMedia.title + '" src="' + videoLink + '" frameborder="0"></iframe>';
        } else if (postItemMedia.url.includes("<iframe")) {
          builtmediaContent += postItemMedia.url;
        } else {
          builtmediaContent += '<a href="' + postItemMedia.url.split("=>")[2] + '" target="_blank" title="Visit ' + postItemMedia.url.split("=>")[2] + '" alt="Visit ' + postItemMedia.url.split("=>")[2] + '">' + postItemMedia.url.split("=>")[1] + "</a>";
        }
      });
    } else if (passedPostTypeiD == 9) {
      // Class type
      passedPostItems.forEach(function (postItemMedia, i) {
        if (postItemMedia.itemType == 1) {
          // Document
          builtmediaContent += '<a href="' + postItemMedia.url + '">' + postItemMedia.title + "</a>";
        } else if (postItemMedia.itemType == 2) {
          // Image
          builtmediaContent += '<img src="' + postItemMedia.url + '" width="' + postItemMedia.width + '" height="' + postItemMedia.height + '" />';
        } else if (postItemMedia.itemType == 3) {
          // Audio
          builtmediaContent += "";
        } else if (postItemMedia.itemType == 4) {
          // Video
          builtmediaContent += "";
        } else if (postItemMedia.itemType == 5) {
          // Other
          builtmediaContent += '<a href="' + postItemMedia.url + '">' + postItemMedia.title + "</a>";
        } else if (postItemMedia.itemType == 6) {
          // Link
          builtmediaContent += '<a href="' + postItemMedia.url.split("=>")[2] + '">' + postItemMedia.url.split("=>")[1] + "</a>";
        }
      });
    } else {
      builtmediaContent += "";
    }
  }

  builtmediaContent += "</div>";
  return builtmediaContent;
};

export default buildMediaContent;